import {U, __, TOOLTIP, short_popup} from "./global";
import Cookies from 'js-cookie';
import {CARD} from './card';
import {DRAWER} from './drawer';
import {GTM} from './gtm';

export const USER = {
    existsrequest: 0,
    window_source: '',
    smsvalid: 0,
    openregister: false,
    callback: false,
    token: '',
    token_counter: 0,
    token_timeout: false,
    token_timeout_time: 30,
    token_current_second: 30,

    // check
    load: function(){
    },

    openFillPhonePopup: function() {
        DRAWER.init('workdrawer-phonewizard workdrawer-full', {
            action: 'users',
            to: 'changephone',
            locale: G.locale_id,
            page: document.location.pathname,
        }, function () {
            U.mask_inputs();
        });
    },

    codeAllowed: function(digits) {
        const allowed_codes = ['050', '066', '095', '099', '039', '067', '096', '097', '098', '063', '073', '091', '092', '094', '070', '080', '090', '093', '068'];
        return allowed_codes.indexOf(digits.substr(0, 3)) >= 0;
    },

    cookie_allowed: function() {
        if (G.channel==1)
            return (Cookies.get("c_u") && (Cookies.get("c_u")==0 || Cookies.get("c_u") > 0)) ? true : false;
        else
            return true;
    },

    show_cookie_popup: function() {
        DRAWER.init('workdrawer-blocked_cookie', {action: 'popup', to: 'blocked_cookie'});
    },

    // check
    possible_submit_auth: function() {
        let result = false;

        if ($(".auth__submit.do-register").length)
            result = true;

        if (!($.trim($(".auth-form .for-password input").val())=='') && !($.trim($(".auth-form .for-phone input").val())==''))
            result = true;

        return result;
    },

    // check
    is_logged: function(){
        let c_l = Cookies.get("c_l");
        if (!c_l || !c_l.length)
            return false;

        return true;
    },

    // check
    logout: function() {

        Cookies.remove('c_l');
        Cookies.remove('user_id');
        Cookies.remove('user_name');
        Cookies.remove('user_email');
        Cookies.remove('user_phone');

        $(".header .user .login").replaceWith('<a href="#" class="login">' + __('Ваш акаунт') + '</a>');

        CARD.set_card_count(0);

        $.post(
            '/aj',
            {
                action: 'users',
                locale: G.locale_id,
                to: 'logout'
            },
            function(data){
                $(".tooltip.user-menu").remove();

                if (document.location.pathname.substr(0, 3)=='/u/' || document.location.pathname.substr(0, 6)=='/ru/u/') {
                    document.location.assign('/');
                    return;
                }

                if (G.b2bmode) {
                    document.location.assign('/');
                    return;
                }

                document.location.reload();


            },
            'json');
    },

    // check
    send_sms: function(source, form = '.tform-auth') {
        form = $(form);

        let send_form = (token) => {
            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'sendcode',
                    locale: G.locale_id,
                    counter: USER.token_counter,
                    phone: form.find('[name=login]').val(),
                    source: source,
                    recaptcha_token: token
                },
                (data) => {
                    if (data.success) {
                        form.find('.auth__smsprompt').html(`Ми надіслали одноразовий код для підтвердження входу на номер ${form.find('[name=login]').val()}`);
                        USER.token = data.token;
                        USER.token_counter++;
                        USER.start_token_timeout();
                    } else {
                        form.find('.alert').html(data.error).removeClass('hidden').addClass('alert-danger');
                    }
                },
                'json');
        };

        if (G.force_recaptcha) {
            let captcha_error_message = 'Не вдалось підтвердити особистість. Спробуйте пізніше, або зверніться в контакт центр.';

            U.loadscript(G.recaptcha_script, () => {
                try {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(G.recaptcha_key, {action: 'submit_form'})
                            .then(function (token) {
                                send_form(token);
                            })
                            .catch(() => {
                                form.find('.alert').html(captcha_error_message).removeClass('hidden').addClass('alert-danger');
                            });
                    });
                } catch (e) {
                    form.find('.alert').html(captcha_error_message).removeClass('hidden').addClass('alert-danger');
                }
            });
        } else {
            send_form();
        }
    },

    // check
    check_sms_code: function(force_login, form = '.tform-auth') {
        form = $(form);
        $(".auth__submit").addClass('loading');
        console.log('check_sms_code');
        $.post(
            '/aj',
            {
                action: 'u',
                to: force_login ? 'checkcode' : 'checkcodename',
                login: force_login ? 1 : 0,
                update: 1,
                locale: G.locale_id,
                token: USER.token,
                code: form.find('[name=codesms]').val(),
                phone: form.find('[name=login]').val().replace(/[^\d]/g, ''),
            },
            function(data){
                $(".auth__submit").removeClass('loading');
                if (data.success) {
                    if (form.parents('.cart').length > 0) {
                        // todo cart
                        CARD.open_checkout();
                        if (force_login) {
                            GTM.event('login', 'sms', data.ut11);
                        }
                    } else {
                        document.location.reload();
                    }
                } else {
                    form.find('.alert').removeClass('hidden').html(data.message);
                }
            },
            'json');
    },

    // check
    switch_form: function(type) {
        let form = $(".tform-auth");
        $(">*", form).addClass('hidden');

        switch(type) {

            case 'register':
                $(".social__login, >h2, [type=submit], .help-register, .for-phone, .for-first-name, .for-middle-name, .for-last-name, .for-email, .for-password, .auth__oneclick", form).removeClass('hidden').find('label span').addClass('hidden');
                $("[type=submit]", form).html(__('Зареєструватись')).data('to', 'register');
                $(">h2", form).html(__('Приємно познайомитись'));
                break;

            case 'registerbtn':
                $("[type=submit]", form).html(__('Зареєструватись')).data('to', 'register');
                break;

            case 'loginpass':
                $(".another_computer, >h2, [type=submit], .for-password, .recovery-buttons, .auth__switch, .auth__switcher", form).removeClass('hidden').find('label span').addClass('hidden');
                $(".auth__switch a", form).removeClass('active');
                $(".auth__switch a[data-to=loginpass]", form).addClass('active');
                $(".help-switcher strong", form).html('+38 ' + $(".for-phone input", form).val());
                $("[type=submit]", form).html(__('Продовжити')).data('to', 'login');
                $(">h2", form).html(__('З поверненням'));
                $("[name=password]", form).focus();
                break;

            case 'registersms':
            case 'loginsms':
            case 'loginsmspasswordless':
                $(".another_computer, >h2, [type=submit], .for-sms, .resend-buttons, .auth__switch, .auth__switcher", form).removeClass('hidden').find('label span').addClass('hidden');
                $(".auth__switch a", form).removeClass('active');
                $(".auth__switch a[data-to=loginsms]", form).addClass('active');
                $(".help-switcher strong", form).html('+38 ' + $(".for-phone input", form).val());
                $("[type=submit]", form).html(__('Продовжити')).data('to', 'sms');
                $(">h2", form).html(__('З поверненням'));

                if (type=='registersms') {
                    $(">h2", form).html(__('Залишився останній крок'));
                    $(".auth__switch, .another_computer", form).addClass('hidden');
                    $(".help-registersms", form).removeClass('hidden');
                }

                if (type=='loginsmspasswordless') {
                    $(".auth__switcher").addClass('hidden');
                }

                $("[name=codesms]", form).focus();

                USER.send_sms('auth');
                break;

            case 'login':
                $(".help-forphone, >h2, .auth__oneclick, [type=submit], .for-phone, .social__login,  .recovery-buttons-register", form).removeClass('hidden').find('label span').addClass('hidden');
                $("[type=submit]", form).html(__('Продовжити')).data('to', 'check');
                $(">h2", form).html(__('Привіт'));
                break;

            default:
                break;
        }
        return;
    },

    // check
    start_token_timeout: function() {
        USER.token_current_second = USER.token_timeout_time;
        clearInterval(USER.token_timeout);
        USER.token_timeout = setInterval(function () {
            USER.token_current_second--;

            if (USER.token_current_second < 1) {
                clearInterval(USER.token_timeout);
                $('.auth__resend').addClass('auth__resend-active').html(__('Відправити ще раз'));
            } else {
                $('.auth__resend').removeClass('auth__resend-active').html(__('Відправити ще раз') + '&nbsp;<strong>(' + USER.token_current_second + ')</strong>');
            }
        }, 1000);
    },

    switch_phonewizard_form: function(type) {
        let form = $(".tform-phonewizard");
        $(">*", form).addClass('hidden');
        switch(type) {
            case 'sms':
                $(".help-confirm, .resend-buttons, [type=submit], .for-sms", form).removeClass('hidden').find('label span').addClass('hidden');
                USER.send_sms('auth', '.tform-phonewizard');
                $("[type=submit]", form).html(__('Продовжити')).data('to', 'checksms');
                $("[name=codesms]", form).focus();
                break;

            case 'main':
                $(".help-forphone, [type=submit], .for-phone", form).removeClass('hidden').find('label span').addClass('hidden');
                $("[type=submit]", form).html(__('Продовжити')).data('to', 'check');
                break;

            default:
                break;
        }
        return;
    },

};

export function init_USER_events() {
    jQuery(document).ready(function () {

        USER.load();

        // check, Показать/спрятать пароль
        jQuery("body").on("click", ".switch-password a", function (e) {
            e.preventDefault();
            let btn = $(this);
            let input = btn.parent().find('input');

            if (input.attr('type') == 'password') {
                input.attr('type', 'text');
                btn.addClass('open');
            } else {
                input.attr('type', 'password');
                btn.removeClass('open');
            }
        });

        // check
        jQuery("body").on("click", ".another_computer a", function (e) {
            e.preventDefault();

            let btn = $(this);
            if (btn.hasClass('active')) {
                btn.removeClass('active');
                $("[name=another_computer]").val(0);
            } else {
                btn.addClass('active');
                $("[name=another_computer]").val(1);
            }
        });

        // check
        jQuery("body").on("click", ".social-buttons a", function (e) {
            let btn = $(this);
            let date = new Date();
            date.setTime(date.getTime() + (180 * 1000));

            Cookies.set("gpl", document.location.pathname, {
                path: '/',
                expires: date
            });

            if (btn.data('action'))
                Cookies.set("auth_action", btn.data('action'), {
                    path: '/',
                    expires: date
                });

            return true;
        });

        // check
        jQuery("body").on("click", ".header__user, .user__mobilebadge", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let btn = $(".header__user");

            if (U.isMobile()) {
                $(".user__menu").addClass('user__menu-visible').removeClass('hidden');
            } else {
                TOOLTIP.open(btn, btn.data());
            }
        });

        // check, switch register
        jQuery("body").on("click", ".switch-register", function (e) {
            e.preventDefault();
            USER.switch_form($(this).data('to'));
        });

        // check, step 1 paste
        jQuery("body").on("paste change", ".auth-form input[name=login], .auth-form input[name=phone]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            let input = $(this);

            let newval = '';

            if (e.type == "paste")
                newval = e.originalEvent.clipboardData.getData('text');

            if (e.type == "change")
                newval = input.val();

            if (newval && (input.attr('name') == 'login' || input.attr('name') == 'phone')) {
                if (newval.substr(0, 4) == '+380')
                    newval = newval.substr(3);

                if (newval.substr(0, 3) == '380')
                    newval = newval.substr(2);

                if (newval.substr(0, 3) == '+38')
                    newval = newval.substr(3);

                input.val($.trim(newval));
            }


            if (!(typeof e.originalEvent === "undefined"))
                input.trigger('keyup');
        });

        // check, step 1 keyup
        jQuery("body").on("keyup", ".tform-auth input", function (e) {
            let input = $(this);
            let btn = $(".auth__submit");
            let action = btn.data('to');
            // input.parents('.form-item').find('label span').addClass('hidden');
            USER.possible_submit_auth();

            switch (input.attr('name')) {
                case 'login':
                    let phone_val = input.val().replace(/\D/g, '');

                    if (phone_val.length == 10) {
                        input.blur();

                        btn.data('to', 'check');
                        btn.trigger('click');
                    }
                    break;

                default:
                    break;
            }
        });

        // auth submit
        jQuery("body").on("click", ".auth__submit", function (e) {
            e.preventDefault();

            let btn = $(this);
            let action = btn.data('to');
            let form = $('.auth-form');

            if (!btn.hasClass('loading') && btn.hasClass('active')) {
                let errors = 0;

                let data = {
                    action: 'u',
                    to: 'recovery',
                    locale: G.locale_id,
                    page: document.location.pathname,
                };

                switch (action) {
                    case 'registerform':
                        USER.switch_form('register');
                        return;
                        break;
                    case 'register':
                        let errors_text = __('Не заповнено всі обов\'язкові поля');
                        let phone_val = form.find('[name=login]').val().replace(/\D/g, '');
                        if (phone_val.length == 10 && phone_val.substr(0, 1).toString() == '0') {
                            form.find('.for-phone label span').addClass('hidden');
                            form.find('.for-phone').removeClass('form-item-error');
                        } else {
                            form.find('.for-phone').addClass('form-item-error');
                            errors++;
                        }

                        let first_name = $.trim(form.find('[name=first_name]').val());
                        let middle_name = $.trim(form.find('[name=middle_name]').val());
                        let last_name = '';

                        if (form.find('[name=first_name]').val() == '' || first_name.length < 2) {
                            errors++;
                            form.find('.for-first-name').addClass('form-item-error');
                        } else {
                            form.find('.for-first-name label span').addClass('hidden');
                            form.find('.for-first-name').removeClass('form-item-error');
                        }

                        if (form.find('[name=middle_name]').val() == '' || middle_name.length < 2) {
                            errors++;
                            form.find('.for-middle-name').addClass('form-item-error');
                        } else {
                            form.find('.for-middle-name label span').addClass('hidden');
                            form.find('.for-middle-name').removeClass('form-item-error');
                        }

                        // check name language
                        let regexp_ua = /^[а-яА-ЯїЇіІьЬ]*$/i;
                        let regexp_en = /^[a-zA-Z]*$/i;

                        /*
                        if (
                            !(
                                (regexp_en.test(first_name) && regexp_en.test(middle_name)) ||
                                (regexp_ua.test(first_name) && regexp_ua.test(middle_name))
                            )
                        ) {
                            errors++;
                            form.find('.for-middle-name').addClass('form-item-error');

                            errors++;
                            form.find('.for-first-name').addClass('form-item-error');

                            errors_text = 'Прізвище та ім\'я має бути введено одною мовою'
                        }
                         */

                        if (form.find('[name=last_name]').length > 0) {
                            last_name = $.trim(form.find('[name=last_name]').val());
                            if (form.find('[name=last_name]').val() == '' || last_name.length < 2) {
                                errors++;
                                form.find('.for-last-name').addClass('form-item-error');
                            } else {
                                form.find('.for-last-name label span').addClass('hidden');
                                form.find('.for-last-name').removeClass('form-item-error');
                            }
                        }

                        if (form.find('[name=password]').val() == '') {
                            errors++;
                            form.find('.for-password').addClass('form-item-error');
                        } else {
                            form.find('.for-password label span').addClass('hidden');
                            form.find('.for-password').removeClass('form-item-error');
                        }

                        if (errors == 0) {
                            form.find('.alert').addClass('hidden');
                            data.action = 'users';
                            data.to = 'register';
                            data.another_computer = $(".another_computer input").val();
                            data.phone = form.find('[name=login]').val().replace(/\D/g, '');
                            data.password = form.find('[name=password]').val();
                            data.name = form.find('[name=first_name]').val() + ' ' + form.find('[name=middle_name]').val() + ' ' + last_name;
                            data.email = form.find('[name=email]').val();
                            data.token = form.find('[name=tkn]').val();

                            data.first_name = $.trim(form.find('[name=first_name]').val());
                            data.middle_name = $.trim(form.find('[name=middle_name]').val());
                            data.last_name = $.trim(form.find('[name=last_name]').val())
                        } else {
                            form.find('.alert').removeClass('hidden').html(errors_text);
                        }
                        break;

                    case 'check':
                        data.action = 'users';
                        data.to = 'check';
                        data.phone = form.find('[name=login]').val().replace(/\D/g, '');

                        if (data.phone.length == 10 && data.phone.substr(0, 1).toString() == '0') {
                            form.find('.for-phone label span').addClass('hidden');
                        } else {
                            form.find('.for-phone label span').removeClass('success').addClass('error').html(__('Невірний номер')).removeClass('hidden');
                            errors++;
                        }
                        break;

                    case 'login':
                        if (form.find('[name=password]').val() == '') {
                            errors++;
                            form.find('.for-password label span').removeClass('success').addClass('error').html(__('Обов\'язково')).removeClass('hidden');
                        } else
                            form.find('.for-password label span').addClass('hidden');

                        if (errors == 0) {
                            data.action = 'users';
                            data.to = 'login';
                            data.another_computer = $(".another_computer input").val();
                            data.phone = form.find('[name=login]').val().replace(/\D/g, '');
                            data.password = form.find('[name=password]').val();
                        }
                        break;

                    case 'sms':
                        let code_val = form.find('[name=codesms]').val().replace(/\D/g, '');
                        console.log(code_val);
                        if (code_val.length == 4) {
                            form.find('.for-sms label span').addClass('hidden');
                        } else {
                            form.find('.for-sms label span').removeClass('success').addClass('error').html(__('Невірний код')).removeClass('hidden');
                            errors++;
                        }

                        if (errors == 0)
                            return USER.check_sms_code(true);
                        break;

                    default:
                        errors = 1;
                        break;
                }

                if (errors == 0) {
                    btn.addClass('loading');
                    // submit
                    $.ajax({
                        type: "POST",
                        url: "/aj",
                        data: data,
                        dataType: "json",
                        timeout: 15000, // in milliseconds
                        success: function (result) {
                            form.find('.alert').addClass('hidden');
                            btn.removeClass('loading');

                            switch (action) {
                                case 'register':
                                    if (result.error) {
                                        form.find('.alert').removeClass('hidden').html(result.error);
                                    } else {
                                        dataLayer.push({
                                            'event': 'signup',
                                            'method': 'password'
                                        });

                                        USER.switch_form('registersms');
                                    }
                                    break;

                                case 'check':
                                    if (!result.success) {
                                        USER.switch_form(result.password ? 'loginpass' : 'loginsmspasswordless');
                                    } else {
                                        if (form.parents('.cart').length > 0)
                                            $("[type=submit]", form).html(__('Зареєструватись')).data('to', 'registerform');
                                        else
                                            USER.switch_form('register');
                                    }
                                    break;

                                case 'login':
                                    if (result.error) {
                                        form.find('.alert').removeClass('hidden').html(result.error);
                                    } else {
                                        if (form.parents('.cart').length) {
                                            CARD.open_checkout();
                                            GTM.event('login', 'password', result.ut11);
                                        }
                                        else
                                            document.location.reload();
                                    }
                                    break;

                                default:
                                    break;
                            }

                            if (form.parents('.cart').length > 0) {
                                $(".auth__oneclick").removeClass('hidden');
                            }

                            GTM.fireStatistick('statistick', 'event', action, 'success');
                        },
                        error: function (result) {
                            switch (action) {
                                case 'register':
                                    form.find('.alert').removeClass('hidden').html(__('Виникла проблема при реєстрації. Спробуйте ще раз'));
                                    break;

                                case 'login':
                                    form.find('.alert').removeClass('hidden').html(__('Виникла проблема при авторизації. Спробуйте ще раз'));
                                    break;

                                default:
                                    break;
                            }

                            GTM.fireStatistick('statistick', 'event', action, 'error');

                            btn.removeClass('loading');
                        }
                    });
                }
            }

            return;
        });

        // check, resend sms
        jQuery("body").on("click", ".auth__resend-active", function (e) {
            e.preventDefault();

            let btn = $(this);

            if (btn.parents('.tform-phonewizard').length > 0) {
                USER.send_sms('sms', '.tform-phonewizard');
            } else if (btn.parents('.recovery-form').length > 0) {
                USER.send_sms('sms', '.recovery-form');
            } else if (btn.parents('.js-popup__bonus200-form').length > 0) {
                USER.send_sms('sms', '.js-popup__bonus200-form');
            } else {
                USER.send_sms('registerresend');
            }

            return;
        });

        // Восстановление пароля
        $(".recovery-form").submit(function (e) {
            // e.preventDefault();
            let userdata = $("[name=userdata]", $(this));

            let response = U.awaitGrecaptchaResponse();
            let errors_count = 0;

            if ($.trim(userdata.val()).length < 8) {
                userdata.parents('.js-form-item').find('.description').css('display', 'table-cell').html(__('Введіть e-mail або телефон'));
                errors_count++;
            } else {
                userdata.parents('.js-form-item').find('.description').css('display', 'none');
            }

            if (response.length == 0) {
                userdata.parents('.js-form-item').find('.description').css('display', 'table-cell').html(__('Підтвердіть, що Ви не робот'));
                errors_count++;
            }

            if (errors_count < 1)
                return true;
            else {
                userdata.parent().find('.alert').removeClass('hidden');
            }
        });

        // Новый пароль
        $(".recovery-password-form").submit(function (e) {
            // e.preventDefault();
            var pass1 = $("[name=pass1]", $(this));
            var pass2 = $("[name=pass2]", $(this));

            var errors_count = 0;

            if ($.trim(pass1.val()).length < 1) {
                pass1.parent().find('label span').removeClass('hidden').html(__('Ви забули ввести пароль'));
                errors_count++;
            } else {
                pass1.parent().find('label span').addClass('hidden');
            }

            if ($.trim(pass1.val()) !== $.trim(pass2.val())) {
                pass2.parent().find('label span').removeClass('hidden').html(__('Паролі повинні співпадати'));
                errors_count++;
            }

            if (errors_count < 1)
                return true;
            else
                return false;
        });

        // recovery
        // Открываем форму восстановления пароля
        jQuery("body").on('click', '.open-recovery-tab', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var btn = $(this);

            DRAWER.init('workdrawer-auth workdrawer-recovery workdrawer-full', {
                action: 'u',
                to: 'recovery',
                case: 'page',
                locale: G.locale_id,
                page: document.location.pathname,
                phone: $(".workdrawer-auth").length ? $(".workdrawer-auth [name=login]").val() : '',
            }, function () {
                U.mask_inputs();

                if (btn.parents('.tform-auth').length == 0)
                    $(".openloginform").addClass('hidden');
            });
        });

        jQuery("body").on("click", ".user-recovery-form [type=submit]", function (e) {
            e.preventDefault();
            var btn = $(this);
            var form = btn.parents('form');
            var phone = form.find("[name=login]");
            var code = form.find("[name=codesms]");
            var password = form.find("[name=password]");

            var errors_count = 0;

            if ($.trim(password.val()).length < 1) {
                password.parent().find('label span').removeClass('hidden');
                errors_count++;
            } else {
                password.parent().find('label span').addClass('hidden');
            }

            if ($.trim(code.val()).length < 4) {
                code.parent().find('label span').removeClass('hidden');
                errors_count++;
            } else {
                code.parent().find('label span').addClass('hidden');
            }

            if (errors_count)
                return;

            $.post(
                '/aj',
                {
                    action: 'u',
                    to: 'recoverycode',
                    locale: G.locale_id,
                    code: code.val(),
                    phone: phone.val(),
                    password: password.val(),
                },
                function (data) {
                    if (data.success) {
                        form.empty().html('<div class="alert">' + data.message + '</div>');
                    } else
                        form.empty().html('<div class="alert">' + data.message + '</div>');
                },
                'json');
            return;
        });

        jQuery("body").on("keyup", ".recovery-form input", function (e) {
            var input = $(this);

            switch (input.attr('name')) {
                case 'email':
                    if (U.validate_email(input.val())) {
                        $(".recovery-form .email-pack [type=submit]").removeClass('hidden').addClass('active');
                    } else {
                        $(".recovery-form .email-pack [type=submit]").removeClass('active');
                    }
                    break;

                case 'login':
                    var digits = input.val().replace(/[^0-9.]/g, "");

                    if (digits.length == 10) {
                        $(".recovery-form .phone-pack [type=submit]").removeClass('hidden').addClass('active');
                        input.blur();
                    } else {
                        $(".recovery-form .phone-pack [type=submit]").removeClass('active');
                    }

                    break;

                default:
                    break;
            }
        });

        jQuery("body").on("click", ".recovery-form .do-action", function (e) {
            e.preventDefault();
            var input = $(this);
            var container = $("." + input.data('container'));
            var action = input.data('action');

            var data = {
                action: 'u',
                to: 'recovery',
                case: action,
                locale: G.locale_id,
                page: document.location.pathname,
            };

            var error = false;

            if (action == 'lookupemail')
                data.email = container.find('[name=email]').val();

            if (action == 'lookupphone')
                data.phone = container.find('[name=login]').val();

            if (action == 'checkcode') {
                data.phone = container.find('[name=login]').val();
                data.code = container.find('[name=codesms]').val();
                data.code = data.code.replace(/[^0-9.]/g, "");
                data.token = USER.token;

                if (!(data.code.length == 4))
                    error = __('Введено невірний код підтвердження');
            }

            if (action == 'sendsms') {
                if (input.hasClass('cancel')) {
                    return;
                } else {
                    data.phone = container.find('[name=login]').val();
                    data.counter = USER.token_counter;
                }
            }

            if (action == 'savenewpassword') {
                data.code = container.find('[name=codesms]').val();
                data.code = data.code.replace(/[^0-9.]/g, "");
                data.token = USER.token;
                data.phone = container.find('[name=login]').val();
                data.password = container.find('[name=password]').val();
                data.password2 = container.find('[name=password2]').val();
            }

            if (action == 'confirmcode') {
                data.code = container.find('[name=code]').val();
            }

            if (action == 'savenewpassword2') {
                data.code = container.find('[name=code]').val();
                data.password = container.find('[name=password]').val();
                data.password2 = container.find('[name=password2]').val();
            }

            if (error) {
                container.find('>.alert').removeClass('hidden').addClass('alert-danger').html(error);
            } else {
                container.find('>.alert').addClass('hidden')
                $.post(
                    '/aj',
                    data,
                    function (result) {
                        if (result.error) {
                            container.find('>.alert').removeClass('hidden');
                            container.find('>.alert').addClass('alert-danger').html(result.error);
                        } else {
                            container.find('>.alert').removeClass('alert-danger').html(result.message);

                            // email
                            if (action == 'lookupemail') {
                                container.find('.for-code').removeClass('hidden');
                                input.data('action', 'confirmcode').html(__('Підтвердити код'));
                                container.find('>.alert').removeClass('hidden');
                            }
                            if (action == 'confirmcode') {
                                container.find('.for-code').addClass('hidden');
                                container.find('.for-email-password').removeClass('hidden');
                                input.data('action', 'savenewpassword2').html(__('Зберегти пароль'));
                            }
                            if (action == 'savenewpassword2') {
                                $(".recovery-form").find('.phone-pack, .form-item-or, .email-pack, >.clearfix').remove();
                                $(".recovery-form").append('<div class="alert">' + result.message + '</div>');
                                setTimeout(function () {
                                    document.location.reload();
                                }, 5000);
                            }

                            // phone
                            if (action == 'lookupphone' || action == 'sendsms') {
                                container.find('.for-sms').removeClass('hidden');


                                USER.token_counter++;
                                USER.token = result.token;
                                USER.start_token_timeout();

                                $(".resend-buttons").removeClass('hidden');

                                if (!(action == 'sendsms'))
                                    input.data('action', 'checkcode').html(__('Відновити пароль'));
                            }
                            if (action == 'checkcode') {
                                container.find('.for-sms').addClass('hidden');
                                container.find('.for-sms-password').removeClass('hidden');
                                container.find('.resend-buttons').addClass('hidden');
                                input.data('action', 'savenewpassword').html(__('Зберегти'));
                                container.find('>.alert').addClass('hidden');
                            }

                            if (action == 'savenewpassword') {
                                $(".recovery-form").find('.phone-pack, .form-item-or, .email-pack, >.clearfix').remove();
                                $(".recovery-form").append('<div class="alert">' + result.message + '</div>');
                                GTM.event('login', 'recovery');
                                setTimeout(function () {
                                    document.location.reload();
                                }, 5000);
                            }
                        }
                    },
                    'json'
                );
            }
        });

        // change phone wizard
        jQuery("body").on("click", ".open-phone-wizard", function (e) {
            e.preventDefault();
            USER.openFillPhonePopup();
            return;
        });

        // change phone wizard
        jQuery("body").on("click", ".js-user__phonewizard", function (e) {
            e.preventDefault();
            let btn = $(this);
            USER.window_source = btn.data('source');
            DRAWER.init('workdrawer-phonewizard workdrawer-full', {
                action: 'users',
                to: 'changephone',
                locale: G.locale_id,
                title: btn.data('title'),
                container: btn.data('container'),
                page: document.location.pathname,
            },  () => {
                U.mask_inputs();
            });
            return;
        });

        // change phone submit
        jQuery("body").on("click", ".auth__phonewizard", function (e) {
            e.preventDefault();

            let btn = $(this);
            let action = btn.data('to');
            let form = $('.auth-form');

            console.log(action);

            if (!btn.hasClass('loading') && btn.hasClass('active')) {
                let errors = 0;

                let data = {
                    action: 'users',
                    to: 'check',
                    locale: G.locale_id,
                    page: document.location.pathname,
                };

                let phone_val = form.find('[name=login]').val().replace(/\D/g, '');

                switch (action) {
                    case 'sendsms':
                        USER.switch_phonewizard_form('sms');
                        return;
                        break;

                    case 'check':

                        if (phone_val.length == 10 && phone_val.substr(0, 1).toString() == '0') {
                            form.find('.for-phone label span').addClass('hidden');
                        } else {
                            form.find('.for-phone label span').removeClass('success').addClass('error').html(__('Невірний номер')).removeClass('hidden');
                            errors++;
                        }

                        if (errors == 0) {
                            data.action = 'users';
                            data.to = 'check';
                            data.phone = form.find('[name=login]').val().replace(/\D/g, '');
                        }
                        break;

                    case 'checksms':
                        let code_val = form.find('[name=codesms]').val().replace(/\D/g, '');
                        if (code_val.length == 4) {
                            form.find('.for-sms label span').addClass('hidden');
                        } else {
                            form.find('.for-sms label span').removeClass('success').addClass('error').html(__('Невірний код')).removeClass('hidden');
                            errors++;
                        }

                        if (errors == 0) {
                            data.action = 'u';
                            data.to = 'checkcode';
                            data.save_phone = 1;
                            data.token = USER.token;
                            data.phone = form.find('[name=login]').val().replace(/\D/g, '');
                            data.code = form.find('[name=codesms]').val().replace(/\D/g, '');
                        }

                        break;

                    default:
                        errors = 1;
                        break;
                }

                if (errors == 0) {
                    btn.addClass('loading');
                    // submit
                    $.ajax({
                        type: "POST",
                        url: "/aj",
                        data: data,
                        dataType: "json",
                        timeout: 15000, // in milliseconds
                        success: function (result) {
                            form.find('.alert').addClass('hidden');
                            btn.removeClass('loading');
                            if (result.error) {
                                switch (action) {
                                    case 'check':
                                        form.find('.alert').removeClass('alert-danger').removeClass('hidden').html(result.error);
                                        $("[type=submit]", form).html(__('Надіслати sms')).data('to', 'sendsms');
                                        break;

                                    default:
                                        form.find('.alert').addClass('alert-danger').removeClass('hidden').html(result.error);
                                        break;
                                }
                            } else {
                                switch (action) {
                                    case 'check':
                                        USER.switch_phonewizard_form('sms');
                                        break;

                                    case 'checksms':
                                        switch (USER.window_source) {
                                            case 'event_happybirthday':
                                                document.location.reload();

                                                break;

                                            default:
                                                if ($(".cart-show").length > 0) {
                                                    // is cart
                                                    CARD.go_step(2);
                                                    $(".tform-phonewizard").addClass('hidden');
                                                } else {
                                                    if (U.isMobile()) {
                                                        if ($(".form-preorder").length > 0) {
                                                            DRAWER.init('workdrawer-writemain_thx workdrawer-full', {
                                                                action: 'popup',
                                                                to: 'preorderthx'
                                                            });
                                                        } else {
                                                            DRAWER.init('workdrawer-writemain_thx workdrawer-full', {
                                                                action: 'popup',
                                                                to: 'newphonesuccess'
                                                            });
                                                        }
                                                    } else {
                                                        DRAWER.destroy();
                                                        short_popup('<div class="exchange-thx"></div><div class="small-text text-center">' + __('Ваш номер телефону успішно змінено') + '</div>');
                                                    }

                                                    // if ($(".profile__form").length > 0) {
                                                    //     setTimeout(() => {
                                                    //         document.location.reload();
                                                    //     }, 3000);
                                                    // }
                                                }
                                                break;
                                        }


                                        break;

                                    default:
                                        break;
                                }
                            }
                        },
                        error: function (result) {
                            switch (action) {
                                case 'check':
                                    form.find('.alert').addClass('alert-danger').removeClass('hidden').html(__('Виникла проблема. Спробуйте ще раз'));
                                    break;

                                default:
                                    break;
                            }

                            btn.removeClass('loading');
                        }
                    });
                }
            }

            return;
        });

        jQuery("body").on("keyup", ".tform-phonewizard input", function (e) {
            let input = $(this);
            let form = input.parents(".tform-phonewizard");
            let submit = form.find('[type=submit]');
            input.parents('.form-item').find('label span').addClass('hidden');

            switch (input.attr('name')) {
                case 'login':
                    let phone_val = input.val().replace(/\D/g, '');
                    form.find('.alert').addClass('hidden');

                    if (phone_val.length == 10 && input.parents('.cart').length == 0) {
                        input.blur();

                        if (form.hasClass('tform-userhaventphone')) {
                            submit.data('to', 'sendsms').trigger('click');
                            return;
                        } else {
                            $(".auth__phonewizard").trigger('click');
                        }
                    }

                    if (submit.data('to')=='sendsms') {
                        submit.html(__('Продовжити')).data('to', 'check');
                    }

                    break;

                default:
                    break;
            }

        });

        // edit profile keyup
        jQuery("body").on("keyup", ".cabinet-change-password input", function () {
            let errors = 0;
            let form = $(this).parents('form');

            if (form.find('[name=old_password]').val() == '') {
                errors++;
            } else
                form.find('[name=old_password]').parent().find('label span').addClass('hidden');

            if (form.find('[name=password]').val() == '') {
                errors++;
            } else
                form.find('[name=password]').parent().find('label span').addClass('hidden');

            if (form.find('[name=password2]').val() == '') {
                errors++;
            } else
                form.find('[name=password2]').parent().find('label span').addClass('hidden');

            if (errors)
                form.find('[type=submit]').removeClass('active');
            else
                form.find('[type=submit]').addClass('active');
        });

        // edit profile keyup
        jQuery("body").on("click", ".js-popup__bonus200-checksms", function (e) {
            e.preventDefault()
            const btn = $(this);
            const form = btn.parents('form');

            if (btn.hasClass('loading'))
                return;

            btn.addClass('loading');

            $.post(
                '/aj',
                {
                    action: 'popup',
                    to: 'bonus200checksms',
                    token: USER.token,
                    code: form.find('[name=codesms]').val(),
                    phone: form.find('[name=login]').val().replace(/[^\d]/g, ''),
                },
                function(data){
                    btn.removeClass('loading');
                    if (data.success) {
                        GTM.fireStatistick('statistick', 'click', 'getcontacts_form_sent', '');
                        DRAWER.init('workdrawer-popup-bonus200 workdrawer-popup-bonus200-success workdrawer-full', {action: 'popup', to: 'bonus200thx'});
                    } else {
                        form.find('.js-popup__bonus200-second .alert').removeClass('hidden').html(data.message);
                    }
                },
                'json');
        });


    });
}